import React, { Component } from "react";
import moment from "moment";
import EditStory from "../../components/CreateStory/EditStory";
import { withRouter } from "react-router-dom";
import {
  Modal,
  ModalBody,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Popover,
  PopoverHeader,
  PopoverBody,
  Row,
  Col,
} from "reactstrap";
import { connect } from "react-redux";
import "./Stories.css";
import axios from "../../axios";
import * as url from "../../utils/url";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import {
  storyReactions,
  uploadPreview,
  get_reaction_text,
  get_reaction_image,
  get_user_initials,
  renderGenderPronoun,
  profilePicValidityCheck,
} from "../../utils/constants";
import * as actionCreators from "../../modules/actions/index";
import { capitalizeFirstLetter } from "../../utils/stringUtils";
import Loading from "../../hoc/Loading/Loading";
import { ListGroup, ListGroupItem } from "reactstrap";
import avatarIcon from "../../assets/default-avatar.png";
import If from "../../components/Shared/If";
import classnames from "classnames";
import { isMobile } from "../../utils/deviceInfo";
import ReactPlayer from "react-player/lazy";
import StoriesPhotoGrid from "./StoriesPhotoGrid";
import StoriesPhotoCarousel from "./StoriesPhotoCarousel";
import ImagePreview from "../../components/Previews/ImagePreview";
import Reactions from "./Reactions.jsx";
import ReportStoryModal from "./ReportStoryModal";

class StoryCommentList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      stories: [],
      archievedStories: [],
      privacy: "PUBLIC",
      isCarouselModal: false,
      isAnonymous: false,
      isAnonymousVisible: true,
      disableSubmit: true,
      showReplies: false,
      mentionsSelected: [],
      mentionsFound: [],
      mentionWord: "",
      isVideo:
        this.props.item.ogp &&
        this.props.item.ogp.ogType &&
        this.props.item.ogp.ogType.indexOf("video") > -1
          ? true
          : false,
      description: {
        value: "",
        error: false,
      },
      response: "",
      mentionBool: false,
      mentionsIndex: 0,
      isCommentsOpen: false,
      dropdownOpen: false,
      title: "",
      showCreateStoryModal: false,
      modalActionType: "Create",
      categoryDefinitionPopoverOpen: false,
      collapseCompleted: true,
      isRemoved: false,
      showUserReactions: false,
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
      userReacted:
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions.filter((e) => {
              return e.userId === this.props.user.profile._id;
            })
          : "null",
      userReactions: [],
      // this.props.item.reactionArr && this.props.item.reactionArr.reactions &&this.props.item.reactionArr.reactions.length>0?this.props.item.reactionArr.reactions:[],
      reactionCounter:
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions.length
          : 0,
      reactionList:
        this.props.item.reactionArr &&
        this.props.item.reactionArr.reactions &&
        this.props.item.reactionArr.reactions.length > 0
          ? this.props.item.reactionArr.reactions
          : [],

      editModalOpen: false,
      selectedCommentObject: null,
    };
  }

  componentDidMount = () => {};

  renderReactionSymbolsUniqley = (reactionsList) => {
    const symbolImagesSet = new Set();

    for (const item of reactionsList) {
      symbolImagesSet.add(item.reaction);
    }

    const symbolImagesArray = Array.from(symbolImagesSet);

    return (
      <div onClick={this.showReactionList} className="reactionsContainer" style={{fontWeight:"400"}}>
        {symbolImagesArray.map((e, idx) => {
          return (
            <img
              className="reactionItems"
              src={this.pickImage(e)}
              key={idx}
              height="100%"
              width="100%"
            />
          );
        })}
        <span className="reactionCounter">{this.state.reactionCounter}</span>
      </div>
    );
  };

  returnSiteName = () => {
    const { item } = this.props;
    if (item) {
      if (item.ogp && item.ogp !== "undefined" && item.ogp !== null) {
        let { ogp } = item;

        let { ogUrl, twitterAppNameGooglePlay, ogSiteName } = ogp;

        let startNameURL = ogUrl.indexOf("w.") + 2;
        let endNameURL = ogUrl.indexOf(".com");
        let startEndDiff = endNameURL - startNameURL;
        let siteName = ogUrl.substr(startNameURL, startEndDiff);

        if (ogSiteName) {
          return ogSiteName;
        } else if (twitterAppNameGooglePlay) {
          return twitterAppNameGooglePlay;
        } else {
          return siteName;
        }
      }
    }
  };

  toggleDropdown = (id) => {
    let { dropdownOpen } = this.state;
    if (dropdownOpen === id) {
      this.setState({ dropdownOpen: "" });
    } else {
      this.setState({ dropdownOpen: id });
    }
  };

  handleCreateStoryResponse = () => {
    const {
      description,
      isAnonymous,
      privacy,
      title,
      mentionsSelected,
    } = this.state;
    const { item } = this.props;
    let isUrl;

    let desValue = description.value.replace(/<\/?![^>]+(>|$)/g, "");

    let desc = `<span> ${description.value.replace(
      /<\/?![^>]+(>|$)/g,
      ""
    )} </span>`;

    // console.log(desc, '----mselect--->' ,mentionsSelected)
    let isMention = desc.indexOf("@") > -1 ? true : false;

    let desArr = desc.split(" ");

    let mArray = desArr.filter((e) => {
      if (e.indexOf("@") > -1) {
        return e;
      }
    });
    // console.log(desc, '--desArr---', desArr,'----marr---', mArray)

    // console.log('----',mArray)
    let mentions = mentionsSelected.filter((e) => {
      let valMention = `({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
      // console.log("---vMention ----", valMention)
      // let wLength = word.length
      if (desc.includes(valMention)) {
        // console.log(e, '---w----',word)
        let strReplace = `@[@${e.name}]({ "_id": "${e._id}", "email": "${e.email}", "name": "${e.name}"})`;
        // console.log(strReplace)
        desc = desc.replace(
          strReplace,
          `<span class="userMentionWord" onClick={this.navigateToProfile}>${e.name}</span>`
        );
        // console.log(desc)
        return e;
      }
    });

    let splitDesc = desc.split(" ").map((e) => {
      let val = e;
      if (e.indexOf("http") > -1 && e.indexOf("www") == -1) {
        isUrl = true;
        val = e.replace(
          /((http|https)?:\/\/[^\s]+)/g,
          `<a class="urlLink" href='$1' target='_blank' >$1</a>`
        );
      } else if (e.indexOf("www") > -1 && e.indexOf("http") == -1) {
        isUrl = true;
        val = e.replace(
          /(www[^\s]+)/g,
          `<a class="urlLink" href='${"https://"}$1' target='_blank' >$1</a>`
        );
      } else if (e.indexOf("www") > -1 && e.indexOf("http") > -1) {
        isUrl = true;
        val = e.replace(
          /((http|https)[^\s]+)/g,
          `<a class="urlLink" href='$1' target='_blank' >$1</a>`
        );
      }
      return val;
    });

    desc = splitDesc.join(" ");

    if (desc.length > 0) {
      let payload = { description: desc, title, isAnonymous, privacy };
      if (isAnonymous) {
        payload.isAnonymous = isAnonymous;
      } else if (isAnonymous === undefined) {
        payload.isAnonymous = false;
      }
      if (mentions && mentions.length > 0) {
        payload.users = mentions;
      }
      payload.isUrl = isUrl;
      payload.parent = item._id;
      payload.isMention = isMention;
      // console.log(payload)
      // return
      axios
        .post(url.createStoryResponse(item._id), payload)
        .then(({ data }) => {
          // this.getStoryFeeds();
          this.setState({
            description: "",
            title: "",
            privacy: true,
            isAnonymous: false,
            mentionsSelected: [],
            mentionsFound: [],
            mentionWord: "",
            showReplies: false,
          });
        });

      this.setState({
        showCreateStoryModal: false,
        description: "",
        title: "",
        privacy: true,
      });
    } else {
      this.setState({ showCreateStoryModal: true });
    }
  };

  handleChangeStoryDescription = (event) => {
    let descriptionContext = event.target.value;
    // let descriptionContext = event.editor.getData();
    // console.log(descriptionContext)
    let word, value;
    let { mentionsFound, mentionWord } = this.state;
    if (descriptionContext === "") {
      word = [];
      value = "";
    } else {
      word = mentionsFound;
      value = mentionWord;
    }
    this.setState({
      description: { value: descriptionContext },
      mentionWord: value,
      mentionsFound: word,
      disableSubmit: descriptionContext.length === 0,
    });
  };

  selectUserMention = (val) => {
    // console.log(val)
    // console.log(val.toString(), typeof val, JSON.parse(val))
    let obj = JSON.parse(val);
    // console.log(obj)
    this.setState((prevState) => ({
      mentionsFound: [],
      mentionWord: "",
      // description: {value: text},
      mentionsSelected: [...prevState.mentionsSelected, obj],
    }));
  };

  addReaction = (val,isAnonymous) => {
    let { user, item } = this.props;
    let { reactionList, userReactions, reactionCounter } = this.state;
    // console.log(reactionCounter)
    // console.log(val)
    // console.log(user)
    let payload = {
      userId: user.profile._id,
      reaction: val,
      _id: val,
      user: user.profile,
      createdOn: Date.now,
      storyId: item._id,
      storyOwner: item.userId,
      orgId: user.profile.organizationId._id,
      isAnonymous
    };

    // if(this.state.reactionList.indexOf(payload.userId)>-1)
    let rList = reactionList;
    let uR = userReactions;
    let isReactionListModified = false;
    let isUserListModified = false;

    rList.map((e) => {
      if (e.userId === payload.userId) {
        e.reaction = payload.reaction;
        isReactionListModified = true;
      }
    });

    uR.map((e) => {
      if (e.user._id === payload.userId) {
        e.reaction = val;
        e._id = val;
        e.user.firstName = payload.user.firstName ? payload.user.firstName : "";
        e.user.lastName = payload.user.lastName ? payload.user.lastName : "";
        e.user.profilePic = profilePicValidityCheck(payload.user.profilePic)
          ? payload.user.profilePic
          : "";
        isUserListModified = true;
      }
    });

    if (isReactionListModified) {
      this.setState((prevState) => ({
        reactionList: [...rList],
      }));
    } else {
      if (reactionList.length < 3) {
        this.setState((prevState) => ({
          reactionList: [
            { reaction: val, userId: user.profile._id },
            ...prevState.reactionList,
          ],
          reactionCounter: prevState.reactionCounter + 1,
        }));
      } else {
        this.setState((prevState) => ({
          reactionCounter: prevState.reactionCounter + 1,
        }));
      }
    }

    if (isUserListModified) {
      this.setState((prevState) => ({
        userReactions: [...uR],
      }));
    } else {
      this.setState((prevState) => ({
        userReactions: [payload, ...prevState.userReactions],
      }));
    }

    axios.post(url.addReaction(item._id), payload).then(({ data }) => {
      this.props.storyMetricsChange({ type: "reactions", value: 1 });
      // console.log(data)
    });
  };

  removeReaction = () => {
    console.log(this.state.userReacted,this.state.userReactions)
    let userRlist =
      this.state.userReacted && this.state.userReacted !== null && this.state.userReacted != "null"
        ? this.state.userReacted
        : this.state.userReactions;
    let reactionList = this.state.reactionList;
    console.log(userRlist);
    // console.log(this.state.userReacted, this.state.userReactions)

    if (userRlist.length > 0 && userRlist && userRlist != null) {
      console.log(userRlist)
      let ulist = userRlist.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // console.log(ulist)
      this.setState((prevState) => ({
        userReacted: [...ulist],
        userReactions: [...ulist],
      }));
    }

    if (reactionList.length > 0) {
      let rlist = reactionList.filter(
        (e) => e.userId != this.props.user.profile._id
      );
      // let rlist = [...reactionList]
      // console.log(rlist)
      this.setState((prevState) => ({
        reactionList: [...rlist],
        reactionCounter: prevState.reactionCounter - 1,
      }));
    }

    axios
      .delete(
        url.deleteReaction(this.props.item._id, this.props.user.profile._id)
      )
      .then(({ data }) => {
        // console.log(data)
        this.props.storyMetricsChange({ type: "reactions", value: -1 });
      });
  };

  fetchUsers = (query, callback) => {
    let users;
    // console.log(query)
    if (!query) return;
    axios
      .get(url.findUser(query))
      .then((resp, idx) =>
        resp.data.data.map((user) => ({
          display: "@" + user.firstName + " " + user.lastName,
          id: `{ "_id": "${user._id}", "email": "${
            user.email
          }", "name": "${user.firstName + " " + user.lastName}"}`,
        }))
      )
      .then(callback);
  };

  handlePermissionChange = (changeEvent) => {
    this.setState({
      isAnonymous: changeEvent.target.checked,
    });
  };

  archiveStory = (id, actionType) => {
    // console.log(id)
    actionType === "Archive" ? this.deleteStory(id) : this.deArchiveStory(id);
    this.toggleDropdown(id);
  };

  deleteStory = (id) => {
    // console.log(id)
    axios.put(url.archiveStory(id)).then((data) => {
      // this.getStoryFeeds();

      this.setState({
        dropdownOpen: false,
      });
      this.showStoryComments(id);
    });
  };

  deArchiveStory = (id) => {
    axios.put(url.deArchiveStory(id)).then((data) => {
      this.getStoryFeeds();
      const result = data;
      this.setState({
        dropdownOpen: false,
      });
    });
  };

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  showStoryRemoveConfirmation = (storyId, value) => {
    // console.log('remove----')
    this.setState({ showRemoveFeedConfirmationModal: true });
    // this.props.removeCommentConfirmation(storyId, 'Reply')
  };

  closeStoryRemoveConfirmation = (storyId) => {
    this.setState({
      showRemoveFeedConfirmationModal: false,
      storyIdRemove: "",
    });
  };

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  };

  createResponse = () => {
    this.setState((prevState) => ({ showReplies: !prevState.showReplies }));
  };

  showStoryComments = (id) => {
    this.props.showStoryComments(id);
  };

  navigateLink = (e) => {
    let className = e.target.className;
    if (isMobile && className == "userMentionWord") {
      e.preventDefault();
    }

    // if(className!=="urlLink"){
    //    e.preventDefault()

    //   let idx= e.target.href.indexOf('home')-1
    //   let link = e.target.href.slice(idx)
    //   this.props.history.push(link);
    // }
  };

  removeReactionHover = () => {
    // console.log('counter---', this.state.reactionCounter)
    this.setState((prevState) => ({
      showReactions: false,
    }));
  };

  goToProfile = (profilePicSrc) => {
    if (isMobile) return;
    let link = "";
    console.log(this.props);
    console.log(this.props.officeMate);
    // dynamic_urls
    if (this.props.item.userId === this.props.user.profile._id) {
      this.props.history.push({
        pathname: `/home/${this.props.item.organizationId}/profile/${this.props.item.userId}`,
      });
    } else {
      this.props.history.push(
        `/home/${this.props.item.organizationId}/profile/${this.props.item.userId}`
      );
    }
  };

  openCarouselModal = (type) => {
    let res = [],
      { item } = this.props;
    if (type == "i") {
      let obj = { url: item.image };
      res.push(obj);
    } else {
      res = [...item.attachments];
    }
    console.log(res, " ----carousel--- ", type);

    this.setState((prevState) => ({
      isCarouselModal: !prevState.isCarouselModal,
      carouselData: res,
    }));
  };

  removeStoryConfirmation = () => {
    let { item, user } = this.props;
    this.setState({ isRemoved: true, dropdownOpen: false });

    axios.put(url.removeStoryFeeds(item._id)).then((resp) => {
      // this.setState({
      //   dropdownOpen: false
      // });
      this.props.changeStoryCounter(-1);
      if (item.userId === user.profile._id)
        this.props.storyMetricsChange({ type: "replies", value: -1 });
    });
  };

  showReactionList = () => {
    const { item } = this.props;
    axios.get(url.userReactions(item._id)).then(({ data }) => {
      // console.log(data.data, this.state.userReactions)
      let value = data.data;
      if (value.storyList && value.storyList.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...value.storyList],
        }));
      } else if (this.state.userReactions.length > 0) {
        this.setState((prevState) => ({
          showUserReactions: true,
          userReactions: [...prevState.userReactions],
        }));
      }
    });
  };

  pickImage = (val) => {
    let selected = storyReactions.filter((x) => x._id === val)[0];
    return selected && selected.image;
  };

  closeReactionModal = () => {
    this.setState({ showUserReactions: false });
  };

  closeCarousel = () => {
    this.setState({ isCarouselModal: false });
  };

  renderAttachments = (images) => {
    let result;
    return images.map((itm, idx) => {
      let itmPreview = uploadPreview(itm);
      if (itm.type && itm.type.mime && itm.type.mime.indexOf("video") > -1) {
        result = (
          <div
            className={`storyUploadPreviewImg sc_list_player_container`}
            onClick={() => this.openCarouselModal()}
            key={idx}
          >
            <ReactPlayer
              width="100%"
              height="100%"
              // controls={true}
              url={itmPreview.preview}
            />
          </div>
        );
      } else {
        if (itmPreview.isMsIcon) {
          result = (
            <div
              className={`storyUploadPreviewImg sc_list_msIcon_container`}
              onClick={() => this.openCarouselModal()}
              key={idx}
            >
              <ImagePreview item={itmPreview} />
            </div>
          );
        } else {
          result = (
            <div
              className={`storyUploadPreviewImg sc_list_img_container`}
              onClick={() => this.openCarouselModal()}
              key={idx}
            >
              <img
                className={`${itmPreview.isMsIcon ? "storiesGridMsIcon" : ""}`}
                src={itmPreview.preview}
              />
            </div>
          );
        }
      }
      return result;
    });
  };

  showReactionText = (reaction) => {
    let res = storyReactions.filter((e) => e._id == reaction._id)[0];
    return (
      <span
        className="story_reaction_modal_rname"
        style={{ color: `${res["color"]}` }}
      >
        {" "}
        {res.name}{" "}
      </span>
    );
  };

  openEditCommentModal = (comment) => {
    this.setState({
      editModalOpen: true,
      selectedCommentObject: { ...comment },
    });
  };

  closeEditCommentModal = () => {
    this.setState({
      editModalOpen: false,
      selectedCommentObject: null,
    });
  };

  renderStories = () => {
    let { isVideo, showRemoveFeedConfirmationModal, reactionList } = this.state;
    const { orgAdmin } = this.props.user.profile;
    const { item, actionType, avatar, description, mentionsFound } = this.props;
    let ogImage,
      ogDesc,
      ogTitle,
      ogType,
      ogUrl,
      ogSiteName,
      ogDescription,
      twitterAppNameGooglePlay,
      ogp;

    if (
      item.hasOwnProperty("ogp") &&
      item.ogp.hasOwnProperty("urlScrape") &&
      item.ogp.urlScrape &&
      isVideo != true &&
      item.attachments.length == 0
    ) {
      ogp = item.ogp;
      // ogp = item.ogp(
      //   ({
      //     ogImage,
      //     ogDesc,
      //     ogTitle,
      //     ogType,
      //     ogUrl,
      //     ogSiteName,
      //     ogDescription,
      //     twitterAppNameGooglePlay,
      //   } = ogp)
      // );
    }

    const dropdown = (
      <Dropdown
        isOpen={this.state.dropdownOpen === item._id ? true : false}
        toggle={() => this.toggleDropdown(item._id)}
        className="wwDropdown reply-dropdown"
      >
        <If condition={orgAdmin || this.props.user.profile._id === item.userId}>
          <DropdownToggle
            tag="span"
            className="chart-item-menu"
            onClick={() => this.toggleDropdown(item._id)}
            data-toggle="dropdown"
            aria-expanded={this.state.dropdownOpen === item._id ? true : false}
          >
            <BiDotsHorizontalRounded
              size={"24px"}
              color="gray"
              style={{ cursor: "pointer" }}
            />
          </DropdownToggle>
        </If>

        <If condition={orgAdmin || this.props.user.profile._id === item.userId}>
          <DropdownMenu
            right
            className="chart-dropdown"
            style={{ padding: "0" }}
          >
            <div>
              <div
                className="chart-list-dropdown-options"
                style={{ display: "flex", margin: "5px" }}
                onClick={() => this.showStoryRemoveConfirmation(item._id)}
              >
                <i className="chart-item-menu flaticon-down"></i>
                <span className="chart-list-dropdown-options-text">
                  Remove from Feed
                </span>
              </div>
              <If condition={this.props.user.profile._id === item.userId}>
                <div
                  className="chart-list-dropdown-options"
                  style={{ display: "flex", margin: "5px" }}
                  onClick={() => {
                    this.openEditCommentModal(item);
                  }}
                >
                  <i className="chart-item-menu flaticon-edit"></i>
                  <span className="chart-list-dropdown-options-text">
                    Edit Comment
                  </span>
                </div>
              </If>
              {/* <If condition={this.props.user.profile._id === item.userId}>
                      <div className="chart-list-dropdown-options"
                        style={{ display: 'flex' }}
                        onClick={() => this.archiveStory(item._id, actionType)}>
                        <If condition={actionType === 'Restore'}>
                          <i className="chart-item-menu flaticon-update"></i>
                        </If>
                        <If condition={actionType === 'Archive'}>
                          <i className="chart-item-menu flaticon-trash"></i>
                        </If>
                        <span className="chart-list-dropdown-options-text">{actionType}</span>
                      </div>
                    </If> */}
            </div>
          </DropdownMenu>
        </If>
      </Dropdown>
    );

    const isFlagged = item.isFlagged && item.isFlagged.status;

    // console.log('reactionList--- ', reactionList)
    return (
      <div className="renderedStoryContainer">
        <div className={`avatar ${isMobile && "reply"} inlineBlock`}>
          {item.isAnonymous ? (
            <img src={avatarIcon} className="avatar-pic noPointer" alt="" />
          ) : item.user &&
            profilePicValidityCheck(item.user.profilePic) &&
            item.user.profilePic.length > 0 ? (
            <img
              onClick={this.goToProfile}
              className="grp_create_search_user_pic"
              src={item.user.profilePic}
            />
          ) : item && item.user ? (
            <span
              className="spotlightUserInitials"
              onClick={this.goToProfile}
              data-letters={this.getInitials(item.user)}
            ></span>
          ) : null}

          <If condition={isMobile}>
            <span className="storyOwner ml-2 ">
              <span className="storyUsername">
                {item.isAnonymous
                  ? "Anonymous user"
                  : this.props.user.profile._id === item.userId
                  ? "me"
                  : item.fullname}
              </span>
              <span className="storyDate">
                {" "}
                on {moment(item.createdOn).format("MMM D, YYYY")}{" "}
              </span>
            </span>
          </If>
        </div>

        <div className="storyResponseList list-group-item">
          <div className="story-list" onClick={(e) => this.navigateLink(e)}>
            <span className="storyOwner ml-0 ">
              <span className="storyUsername">
                {item.isAnonymous
                  ? "Anonymous user"
                  : this.props.user.profile._id === item.userId
                  ? "me"
                  : item.fullname}
              </span>
              {item.isAnonymous ? (
                ""
              ) : (
                <span className="storyDate">
                  {renderGenderPronoun(item.user)}
                </span>
              )}
              <span className="storyDate commentDateAlign">
                {" "}
                {moment(item.createdOn).format("MMM D, YYYY")}{" "}
              </span>
            </span>

            {!isFlagged ? (
              <span
                className="trendingStoriesCommentsList"
                dangerouslySetInnerHTML={this.createMarkup(
                  item.description.replace(/\n/g, "<br />")
                )}
              ></span>
            ) : (
              <span className="text-danger font-weight-bold">
                This comment has been reported. It is currently under review by
                your organization’s EA.
              </span>
            )}

            {!isFlagged && <If condition={!isMobile}>{dropdown}</If>}
          </div>

          <ReportStoryModal
            story={item}
            handleFlagSuccess={this.handleEditSuccess}
            handleUnflagSuccess={this.props.showStoryComments}
            isComment
            orgAdmin={orgAdmin}
          />

          {(item && item.image) ||
          (item && item.attachments && item.attachments.length > 0) ||
          (item && item.hasOwnProperty("ogp")) ? (
            <div className="taskUploadPreviewContainer mb0 commentImageSectionContainer">
              {!isFlagged && (
                <div className="taskUploadPreviewContainerOverflow commentImageSectionRow">
                  {item &&
                  item.hasOwnProperty("ogp") &&
                  item.ogp.hasOwnProperty("urlScrape") &&
                  isVideo != true &&
                  !item.hasOwnProperty("attachments") ? (
                    <div className="ogPreviewCreateContainer">
                      <div className="ogPreviewContainer">
                        <img src={ogImage.url} className="ogPreviewImage" />
                        <span className="ogPreviewContent">
                          <span className="ogPreviewSite">
                            <a href={ogUrl} target="_blank">
                              {/* {item.ogp.ogTitle} */}
                              {this.returnSiteName()}
                            </a>
                          </span>
                          <span className="ogPreviewTitle">{ogTitle}</span>
                          {/* {ogDescription &&ogDescription.length>0 ? <span className='ogPreviewDescription'>{ogDescription}</span>:null} */}
                        </span>
                      </div>
                    </div>
                  ) : null}

                  {isVideo ? (
                    <span className="storyUploadPreviewImg">
                      <ReactPlayer
                        width="100%"
                        controls={true}
                        url={item.ogp.ogUrl}
                      />
                    </span>
                  ) : null}

                  {item.attachments && item.attachments.length > 0
                    ? this.renderAttachments(item.attachments)
                    : null}

                  {item.image &&
                  (item.attachments == null ||
                    (item.attachments && item.attachments.length == 0)) ? (
                    <div className="imgFixContainer">
                      <img
                        onClick={() => this.openCarouselModal("i")}
                        src={item.image}
                        className="imgFix imgCursor"
                      />
                    </div>
                  ) : null}
                </div>
              )}
            </div>
          ) : null}

          {!isFlagged && (
            <div className="reactionsHover d-flex">
              <Reactions
                removeReaction={this.removeReaction}
                saveReaction={this.addReaction}
                hideReactions={this.state.showReactions}
                userReacted={this.state.userReacted}
              />

              {!isFlagged && reactionList && reactionList.length > 0 ? (
                <div className="story_comment_reaction_new">
                  {this.renderReactionSymbolsUniqley(reactionList)}
                </div>
              ) : null}
            </div>
          )}
        </div>

        {!isFlagged && this.state.isCarouselModal ? (
          <StoriesPhotoCarousel
            closeCarousel={this.closeCarousel}
            attachments={this.state.carouselData.sort(function(a, b) {
              return b.size - a.size;
            })}
            // attachments={item.attachments}
            showCarousel={this.state.isCarouselModal}
          />
        ) : null}

        <Modal
          isOpen={showRemoveFeedConfirmationModal}
          className="archive-modal remove-story-model"
        >
          <ModalBody>
            <div className="modal-title">
              Remove reply
              {/* <span className="model-close" onClick={this.closeStoryRemoveConfirmation}>
                        <i className="flaticon-close"></i>
                      </span> */}
            </div>
            <div className="modal-content-wrapper word-break">
              You are about to remove this reply. This action is irreversible
              and will completely delete the reply. <br />
              No one, including the author of the comment, will be able to see
              it any more.
            </div>
            <Row
              className="mt30 remove-story-buttons"
              style={{ marginLeft: "9px" }}
            >
              <Col sm={{ size: 4 }} md={{ size: 4 }}>
                <Button
                  className="archive-button"
                  onClick={this.removeStoryConfirmation}
                >
                  Remove{" "}
                </Button>{" "}
              </Col>
              <If condition={!isMobile}>
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="cancel-button float-right"
                    onClick={this.closeStoryRemoveConfirmation}
                  >
                    Cancel
                  </Button>
                </Col>
              </If>
            </Row>
          </ModalBody>
        </Modal>

        {this.state.showUserReactions ? (
          <Modal
            isOpen={this.state.showUserReactions}
            className="archive-modal show-user-reactions"
          >
            <ModalBody>
              <div className="modal-title reactionListTitle">
                {this.state.userReactions.length} Reactions
              </div>
              <div className="modal-content-wrapper word-break reactionModal">
                {this.state.userReactions && this.state.userReactions.length > 0
                  ? this.state.userReactions.map((e, idx) => {
                      return (
                        <div className="userReactionContainer" key={idx}>
                          <div>
                          {e.isAnonymous ? <img
                              //  onClick={this.goToProfile}
                              className="userReactionPic"
                              src={avatarIcon}
                            /> :e.user && 
                          profilePicValidityCheck(e.user.profilePic) &&
                          e.user.profilePic.length > 0 ? (
                            <img
                              //  onClick={this.goToProfile}
                              className="userReactionPic"
                              src={e.user.profilePic}
                            />
                          ) : e.user.firstName && e.user.lastName ? (
                            <span
                              className="spotlightUserInitials"
                              // onClick={this.goToProfile}
                              data-letters={get_user_initials(e.user)}
                            ></span>
                          ) : null}

                          {/* <img className="userReactionPic" src={e.user.profilePic || UserIcon4}/> */}
                          <span className="userReactionName">
                         {e.isAnonymous ?  e.userId ==  this.props.user.profile._id ? "You (anonymous)" : "Anonymous User" :  <span>{e.user.firstName} {e.user.lastName}</span>  } 
                           
                          </span>
                          </div>

                          <div>
                          <img
                              className="reactionModalImage"
                              src={get_reaction_image(e._id)}
                              //  src={this.pickImage(e._id)}
                            />
                          {this.showReactionText(e)}
                          </div>

                          {/* {get_reaction_text(e)} */}
                          
                        </div>
                      );
                    })
                  : null}
              </div>

              <Row
                className={`mt30 ${isMobile && "reaction-close"}`}
                style={{ marginLeft: "9px" }}
              >
                <Col sm={{ size: 4 }} md={{ size: 4 }}>
                  <Button
                    className="archive-button"
                    onClick={this.closeReactionModal}
                  >
                    Close
                  </Button>{" "}
                </Col>
                {/* <Col sm={{ size: 4 }} md={{ size: 4 }}>
                      <Button className="cancel-button float-right" onClick={this.closeReactionModal}>
                          Cancel
                      </Button>
                    </Col> */}
              </Row>
            </ModalBody>
          </Modal>
        ) : null}
      </div>
    );
  };

  getStoriesCount = () => {
    // const filteredStories = this.state.stories.filter((story) => !story.isDeleted);
    const filteredStories = this.state.stories;

    return filteredStories.length;
  };

  handleCollapse = () => {
    this.setState((state) => ({ collapseCompleted: !state.collapseCompleted }));
  };

  handleEditSuccess = (data) => {
    if (this.props.handleCommentUpdate) {
      this.props.handleCommentUpdate(data);
    }
  };

  renderContent = () => {
    let { isCommentsOpen, isRemoved } = this.state;
    if (!isRemoved) {
      return (
        <div
          className={
            isCommentsOpen === false ? "storyResponseContainer" : "hideComments"
          }
        >
          {this.state.editModalOpen && this.state.selectedCommentObject ? (
            <EditStory
              isComment
              editPopupOpen={this.state.editModalOpen}
              toggleEditPopup={this.closeEditCommentModal}
              storyId={this.state.selectedCommentObject._id}
              story={this.state.selectedCommentObject}
              {...this.props}
              onEditSuccess={this.handleEditSuccess}
            />
          ) : (
            ""
          )}

          {this.renderStories()}
        </div>
      );
    } else {
      return <div></div>;
    }
  };

  render() {
    let { isCommentsOpen, isRemoved } = this.state;
    return this.renderContent();
    // return(<div className={isCommentsOpen===false?"storyResponseContainer":"hideComments"}>
    //     {this.renderStories()}
    //   </div>)
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    storyMetricsChange: (data) =>
      dispatch(actionCreators.storyMetricsChange(data)),
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(StoryCommentList, axios)));
